import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import ProductCard from "@/components/ProductCard";
import ProductModal from "@/components/ProductModal";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TABS = [
  { key: "all", label: "ALL" },
  { key: "men", label: "MEN" },
  { key: "women", label: "WOMEN" },
  { key: "accessories", label: "ACCESSORIES" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const cat = (params.get("cat") || "all").toLowerCase();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () => (cat === "all" ? products : products.filter((p) => p.category.toLowerCase() === cat)),
    [products, cat]
  );

  return (
    <main data-testid="shop-page" className="pt-16 md:pt-20">
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pt-16 md:pt-24 pb-12">
        <p className="text-[10px] tracking-[0.35em] text-[#D3FF24] mb-4">DAFITEXCHANGE — FULL CATALOG</p>
        <h1 className="font-display font-black tracking-tighter leading-none text-5xl md:text-7xl">
          THE FULL <span className="text-outline">ARSENAL</span>
        </h1>
        <p className="text-sm text-white/50 mt-5 max-w-md">
          {filtered.length} pieces. Every one built to be trained in, sweated in, and lived in.
        </p>

        <div className="flex flex-wrap gap-2 mt-10" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`filter-tab-${t.key}`}
              onClick={() => setParams(t.key === "all" ? {} : { cat: t.key })}
              className={`px-5 py-2.5 text-[11px] font-bold tracking-[0.25em] border transition-colors duration-300 ${
                cat === t.key
                  ? "bg-[#D3FF24] text-[#0A0A0C] border-[#D3FF24]"
                  : "border-white/15 text-white/60 hover:border-[#D3FF24]/60 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-24 md:pb-32">
        {loading ? (
          <div data-testid="shop-loading" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-[#111114] animate-pulse" />
            ))}
          </div>
        ) : (
          <motion.div layout className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {filtered.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} onQuickView={setActive} />
            ))}
          </motion.div>
        )}
      </section>

      <ProductModal product={active} onClose={() => setActive(null)} />
      <Footer />
    </main>
  );
}
